import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: '/request',
  htmlTitle: 'Data Privacy Requests',
  htmlTitleLangKey: 'app.htmlTitle',
  createRootApi: true,
  logFetchErrors: {
    options: {
      ignoreErrors: [/failed with status 0/i]
    }
  }
});